'use client';

import { CheckoutControl } from 'components/ui/organisms/checkout/components/checkout-control';
import { CheckoutTest } from 'components/ui/organisms/checkout-test/components/checkout';
import MonarchResolver from 'components/ui/organisms/monarch/MonarchResolver';
import { MonarchRuleProvider } from 'components/ui/organisms/monarch/MonarchRulesProvider';
import { CheckoutTestResult } from 'components/ui/organisms/monarch/rules/checkout/types';
import { TasticProps } from '../types';
import { CheckoutDataSource } from './types';

const CUSTOM_RULE_ID = 'checkout';

const CheckoutTastic = ({ data }: TasticProps<CheckoutDataSource>) => (
  <MonarchRuleProvider>
    <MonarchResolver<CheckoutTestResult>
      experimentKey={CUSTOM_RULE_ID}
      variants={{
        control: (
          <CheckoutControl
            stripePublishableKey={data.STRIPE_PUBLISHABLE_KEY.dataSource}
          />
        ),
        test: (
          <CheckoutTest
            stripePublishableKey={data.STRIPE_PUBLISHABLE_KEY.dataSource}
          />
        ),
      }}
      fallbackVariant="control"
    />
  </MonarchRuleProvider>
);

export default CheckoutTastic;
